import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DesignBoard from "../components/design/design-board";
import { getTemplateById } from "../api/admin/templates";
import usePageTitle from "../hooks/usePageTitle";

const Design = () => {
  const params = useParams();

  const [template, setTemplate] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);

  usePageTitle(
    isEditMode ? `Edit Template: ${template?.internalName}` : "Create Template"
  );

  const loadTemplateById = async (id: string) => {
    // fetch the template by id
    const response = await getTemplateById(id);
    if (!response || response.status !== 200) {
      setError("Error loading template");
      setLoading(false);
      setIsEditMode(false);
      return;
    }

    setIsEditMode(true);
    setTemplate(response.data);
    setError(null);
    setLoading(false);
  };

  useEffect(() => {
    console.log("params from effect.", params);
    if (params.id) {
      loadTemplateById(params.id);
    } else {
      setIsEditMode(false);
      setLoading(false);
      setError(null);
    }
    // reset the state when unmounting

    return () => {
      setTemplate(null);
      setLoading(false);
      setError(null);
      setIsEditMode(false);
    };
  }, []);

  return (
    <div>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}

      {!loading && !error && (
        <DesignBoard templateData={template} isEditMode={isEditMode} />
      )}
    </div>
  );
};

export default Design;
